<template>
    <form-row title="Who Pays Title?">
        <buyer-seller-split
            field="title_who_pays"
            :value="commercial.title_who_pays"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
import BuyerSellerSplit from '../buyer-seller-split.vue';

export default {
    components: {
        BuyerSellerSplit,
    },

    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
